const createMemoryHistory = require('history').createMemoryHistory;
const createBrowserHistory = require('history').createBrowserHistory;

export const createUniversalHistory = () => {
  return createMemoryHistory();
  const appHistory = window.browserHistory || createMemoryHistory();
  if (process.env.NODE_ENV === 'development' && !window.browserHistory) {
    window.browserHistory = appHistory;
  }
  // return appHistory;
};

export default createUniversalHistory;
